import { motion } from "motion/react";

import { ProductGrid } from "@/theme1/components/product/ProductGrid";

const collectionGridVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};

export default function CollectionTemplateGrid({
  title,
  description,
  products,
}) {
  const hasProducts = Array.isArray(products) && products.length > 0;

  return (
    <section
      id="collection-products"
      className="scroll-mt-32 pb-20 sm:pb-24 lg:pb-32"
    >

      {hasProducts ? (
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          variants={collectionGridVariants}
        >
          <ProductGrid products={products} />
        </motion.div>
      ) : (
        <div className="rounded-[2rem] border border-dashed border-border bg-neutral-100/30 p-10 text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-muted-foreground">
            No products yet
          </p>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-muted-foreground">
            Products have not been assigned to this collection yet.
          </p>
        </div>
      )}
    </section>
  );
}
